import React, { useContext } from 'react';
import { useMutation } from '@apollo/client';
import { set } from 'lodash';

import Button from '@react/react-spectrum/Button';
import Delete from '@react/react-spectrum/Icon/Delete';
import Dialog from '@react/react-spectrum/Dialog';
import Heading from '@react/react-spectrum/Heading';
import Edit from '@react/react-spectrum/Icon/Edit';
import ModalTrigger from '@react/react-spectrum/ModalTrigger';

import { RootContext } from '../../../root/RootContext';
import { useSidebar } from '../../../views/App';
import {
  UPSERT_THIRD_PARTY_PRODUCT_MUTATION,
  DELETE_THIRD_PARTY_PRODUCT_MUTATION
} from '../../../data/queries';

import EditDialogContent from './EditDialogContent';

import './ThirdPartyProductSidebar.scss';

export default function ThirdPartyProductSidebar() {
  const { state, dispatch } = useContext(RootContext);
  const { hide: hideSidebar } = useSidebar();

  const [upsertThirdPartyProduct] = useMutation(
    UPSERT_THIRD_PARTY_PRODUCT_MUTATION
  );
  const [deleteThirdPartyProduct] = useMutation(
    DELETE_THIRD_PARTY_PRODUCT_MUTATION
  );

  const product = state.activeThirdPartyProduct;

  const updateProduct = () => {
    upsertThirdPartyProduct({ variables: product });

    dispatch({
      type: 'thirdPartyProducts/UPDATED'
    });
  };

  const deleteProduct = () => {
    deleteThirdPartyProduct({
      variables: { id: product.id }
    });

    hideSidebar();

    dispatch({
      type: 'thirdPartyProducts/UPDATED',
      fetchThirdPartyProducts: true
    });
  };

  return (
    <div className="third-party-product-sidebar">
      <section className="heading-section">
        <Heading size={2}>{product.name}</Heading>
        <Heading variant="subtitle3">{product.type}</Heading>
      </section>

      <section>
        <Heading variant="subtitle1">Actions</Heading>
        <div>
          <ModalTrigger>
            <Button variant="primary" icon={<Edit />} quiet>
              Edit
            </Button>
            <Dialog
              confirmLabel="Save"
              cancelLabel="Cancel"
              onConfirm={updateProduct}
              className="edit-third-party-product-dialog">
              <EditDialogContent
                formData={product}
                setFormData={(key, value) => set(product, key, value)}
              />
            </Dialog>
          </ModalTrigger>
        </div>

        <div>
          <ModalTrigger>
            <Button variant="warning" icon={<Delete />} quiet>
              Delete
            </Button>
            <Dialog
              variant="destructive"
              title="Warning"
              confirmLabel="OK"
              cancelLabel="Cancel"
              onConfirm={deleteProduct}>
              Do you want to delete selected environment?
            </Dialog>
          </ModalTrigger>
        </div>
      </section>
    </div>
  );
}
